import axios from 'CanExConfig/axios'

export const searchUniversities = async term => {
  const response = await axios('/search/universities', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}
